var map = {
	"./logo.png": 338,
	"./section-2.jpg": 879,
	"./section-3.webp": 73,
	"./section-4.jpg": 685,
	"./signuplogin.avif": 974,
	"./signuplogin.jpeg": 898,
	"./signuplogin.webp": 855,
	"./tourist-1.avif": 995,
	"./tourist-2.jpg": 40,
	"./tourist-3.webp": 165,
	"./tourist-4.jpg": 36,
	"./tourist-5.jpg": 162,
	"./tourist-6.png": 253,
	"./tourist-7.jpg": 795,
	"./tourist-8.jpg": 885,
	"./whyus-1.png": 199,
	"./whyus-2.png": 961,
	"./whyus-3.png": 647,
	"./whyus-4.png": 703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;